/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useRoutes } from "react-router-dom";
import { MainRoutes } from "./main-routes";
// import { Logger } from "cms/utils/log/logger";

const Routes = () => {

    const routes = useRoutes([MainRoutes]);
    // Logger.debug(`Loading Routes via react router.`)
    // Logger.flush()
    return routes;
};

export { Routes };
